import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';


const popoverRoot = document.getElementById('popover-root') || document.body;

export const createPopover = (options) => {
  const {
    closable = true,
    component,
    refElement,
    callback = () => { },
  } = options;

  const div = document.createElement('div');
  popoverRoot.appendChild(div);

  const closePopover = (e) => {
    callback(e);
    if (popoverRoot.contains(div)) {
      ReactDOM.unmountComponentAtNode(div);
      popoverRoot.removeChild(div);
      resetRefStyles();  // Revert the refElement's styles
    }
  };

  const setRefStyles = () => {
    if (refElement) {
      refElement.style.zIndex = 999;  // Place refElement above the overlay
      refElement.style.position = 'relative';  // Ensure proper positioning
    }
  };

  const resetRefStyles = () => {
    if (refElement) {
      refElement.style.zIndex = '';  // Revert z-index
      refElement.style.position = '';  // Revert position
    }
  };

  const Popover = () => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const popoverRef = useRef(null);

    useEffect(() => {
      if (refElement) {
        const rect = refElement.getBoundingClientRect();
        setPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        });
        setRefStyles(); 
      }
    }, [refElement]);

    return ReactDOM.createPortal(
      <div className="popover-overlay">
        <div
          className="popover"
          ref={popoverRef}
          style={{ top: `${position.top}px`, left: `${position.left}px` }}
          onClick={(e) => e.stopPropagation()}
        >
          {component}
          {closable && <button onClick={closePopover}>Close</button>}
        </div>
      </div>,
      div
    );
  };

  ReactDOM.render(<Popover />, div);
};
